import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductsProfileComponent } from './products/products-profile/products-profile.component';
import { ProductsBaseComponent } from './products/products-base/products-base.component';
import { ProductsFeedbackComponent } from './products/products-feedback/products-feedback.component';
import { ProductsCheckoutComponent } from './products/products-checkout/products-checkout.component';
import { ProductsUserZoneComponent } from './products/products-user-zone/products-user-zone.component';

const routes: Routes = [
  {
    path: '',
    component: ProductsProfileComponent
  },
  // Products & Services
  // {
  //   path: 'seleccion-perfil',
  //   component: ProductsProfileComponent
  // },
  // {
  //   path: 'seleccion-base',
  //   component: ProductsBaseComponent
  // },
  {
      path: 'arma-tu-plan',
      component: ProductsBaseComponent
    },
  {
    path: 'seleccion-ideal',
    loadChildren: () => import('./products/products-ideal/products-ideal.module').then(m => m.ProductsIdealModule)
  },
  {
    path: 'productos-feedback',
    component: ProductsFeedbackComponent
  },
  {
    path: 'pagos',
    loadChildren: () => import('./products/products-payment/products-payment.module').then(m => m.ProductsPaymentModule)
  },
  {
    path: 'checkout',
    component: ProductsCheckoutComponent
  },
  {
    path: 'zona-de-usuario',
    component: ProductsUserZoneComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
